// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmallCaps-module__font-s-10___ayzXB {
  font-size: 10px !important;
}

.SmallCaps-module__font-s-12___Kje6o {
  font-size: 12px !important;
}

.SmallCaps-module__font-s-13___sazbM {
  font-size: 13px !important;
}

.SmallCaps-module__font-s-14___qFy90 {
  font-size: 14px !important;
}

.SmallCaps-module__font-s-15___Nl3zI {
  font-size: 15px !important;
}

.SmallCaps-module__font-s-16___dVCnX {
  font-size: 16px !important;
}

.SmallCaps-module__font-s-18___veGi5 {
  font-size: 18px !important;
}

.SmallCaps-module__font-s-20___pOAN6 {
  font-size: 20px !important;
}

.SmallCaps-module__font-s-22___a63nr {
  font-size: 22px !important;
}

.SmallCaps-module__font-s-28___OAV13 {
  font-size: 28px !important;
}

.SmallCaps-module__font-w-400___u056O {
  font-weight: 400 !important;
}

.SmallCaps-module__font-w-500___ZJNh1 {
  font-weight: 500 !important;
}

.SmallCaps-module__font-w-600___t4ZDj {
  font-weight: 600 !important;
}

.SmallCaps-module__font-w-700___ipWoM {
  font-weight: 700 !important;
}

.SmallCaps-module__p-5___bgq2J {
  padding: 5px !important;
}

.SmallCaps-module__p-12___FW2LX {
  padding: 12px !important;
}

.SmallCaps-module__p-16___Vj4xQ {
  padding: 16px !important;
}

.SmallCaps-module__p-30____dD23 {
  padding: 30px !important;
}

.SmallCaps-module__p-b-0___lqEws {
  padding-bottom: 0 !important;
}

.SmallCaps-module__p-b-5___NGtgJ {
  padding-bottom: 5px !important;
}

.SmallCaps-module__p-b-10___fZW6z {
  padding-bottom: 10px !important;
}

.SmallCaps-module__p-b-12___v8VVf {
  padding-bottom: 12px !important;
}

.SmallCaps-module__p-b-16___Xd_Jv {
  padding-bottom: 16px !important;
}

.SmallCaps-module__p-b-18___YTVy8 {
  padding-bottom: 18px !important;
}

.SmallCaps-module__p-b-20___dc1tL {
  padding-bottom: 20px !important;
}

.SmallCaps-module__p-b-25___c1ZuR {
  padding-bottom: 25px !important;
}

.SmallCaps-module__p-b-30___fNCW0 {
  padding-bottom: 30px !important;
}

.SmallCaps-module__p-b-50____bf_i {
  padding-bottom: 50px !important;
}

.SmallCaps-module__p-t-0___fAdTf {
  padding-top: 0 !important;
}

.SmallCaps-module__p-t-12___Lhm2n {
  padding-top: 12px !important;
}

.SmallCaps-module__p-t-16___tBRBj {
  padding-top: 16px !important;
}

.SmallCaps-module__p-t-18___weJzq {
  padding-top: 18px !important;
}

.SmallCaps-module__p-t-20___Zhyt0 {
  padding-top: 20px !important;
}

.SmallCaps-module__p-t-30___hgb9n {
  padding-top: 30px !important;
}

.SmallCaps-module__p-t-40____DVC7 {
  padding-top: 40px !important;
}

.SmallCaps-module__p-t-50___hoLJb {
  padding-top: 50px !important;
}

.SmallCaps-module__p-l-20___DEFvK {
  padding-left: 20px !important;
}

.SmallCaps-module__p-l-30___J4m9i {
  padding-left: 30px !important;
}

.SmallCaps-module__p-l-40___CDXPN {
  padding-left: 40px !important;
}

.SmallCaps-module__p-r-16___aVV87 {
  padding-right: 16px !important;
}

.SmallCaps-module__p-r-20___Ftqjc {
  padding-right: 20px !important;
}

.SmallCaps-module__p-r-30___ByM8m {
  padding-right: 30px !important;
}

.SmallCaps-module__p-r-50___g_mTq {
  padding-right: 50px !important;
}

.SmallCaps-module__p-r-60___m1MzD {
  padding-right: 60px !important;
}

.SmallCaps-module__m-b-1___GBddB {
  margin-bottom: 1px !important;
}

.SmallCaps-module__m-b-2___FLTR6 {
  margin-bottom: 2px !important;
}

.SmallCaps-module__m-b-6___WNnKn {
  margin-bottom: 6px !important;
}

.SmallCaps-module__m-b-8___uYrig {
  margin-bottom: 8px !important;
}

.SmallCaps-module__m-b-10___Gwb2A {
  margin-bottom: 10px !important;
}

.SmallCaps-module__m-b-14___D3uiX {
  margin-bottom: 14px !important;
}

.SmallCaps-module__m-b-16___uMBNi {
  margin-bottom: 16px !important;
}

.SmallCaps-module__m-b-20___gv3qC {
  margin-bottom: 20px !important;
}

.SmallCaps-module__m-b-22___fGKYq {
  margin-bottom: 22px !important;
}

.SmallCaps-module__m-b-24___TYnrN {
  margin-bottom: 24px !important;
}

.SmallCaps-module__m-b-30___QbAFc {
  margin-bottom: 30px !important;
}

.SmallCaps-module__m-b-32___VH_Ai {
  margin-bottom: 32px !important;
}

.SmallCaps-module__m-b-40___INmot {
  margin-bottom: 40px !important;
}

.SmallCaps-module__m-t-2___VqNaP {
  margin-top: 2px !important;
}

.SmallCaps-module__m-t-3___ntkNt {
  margin-top: 3px !important;
}

.SmallCaps-module__m-t-4___X2gFp {
  margin-top: 4px !important;
}

.SmallCaps-module__m-t-5___W1tYB {
  margin-top: 5px !important;
}

.SmallCaps-module__m-t-8___AH6LM {
  margin-top: 8px !important;
}

.SmallCaps-module__m-t-10___CwQF6 {
  margin-top: 10px !important;
}

.SmallCaps-module__m-t-15___Au0Xi {
  margin-top: 15px !important;
}

.SmallCaps-module__m-t-16___YF682 {
  margin-top: 16px !important;
}

.SmallCaps-module__m-t-20___G8aLt {
  margin-top: 20px !important;
}

.SmallCaps-module__m-t-22___E6hOH {
  margin-top: 22px !important;
}

.SmallCaps-module__m-t-30___VJx90 {
  margin-top: 30px !important;
}

.SmallCaps-module__m-t-32___odyqC {
  margin-top: 32px !important;
}

.SmallCaps-module__m-l-auto___qTBli {
  margin-left: auto !important;
}

.SmallCaps-module__m-l-4___WZoK6 {
  margin-left: 4px !important;
}

.SmallCaps-module__m-l-5___VuwsW {
  margin-left: 5px !important;
}

.SmallCaps-module__m-l-6___ouHKD {
  margin-left: 6px !important;
}

.SmallCaps-module__m-l-8___C4IqL {
  margin-left: 8px !important;
}

.SmallCaps-module__m-l-10___YPmSm {
  margin-left: 10px !important;
}

.SmallCaps-module__m-l-16___rCAvq {
  margin-left: 16px !important;
}

.SmallCaps-module__m-l-20___P8rNc {
  margin-left: 20px !important;
}

.SmallCaps-module__m-l-24___U7h7l {
  margin-left: 24px !important;
}

.SmallCaps-module__m-l-30___ll5BA {
  margin-left: 30px !important;
}

.SmallCaps-module__m-l-35___QX6lA {
  margin-left: 35px !important;
}

.SmallCaps-module__m-l-40___njsmj {
  margin-left: 40px !important;
}

.SmallCaps-module__m-r-8___yVB1v {
  margin-right: 8px !important;
}

.SmallCaps-module__m-r-10___GsYIB {
  margin-right: 10px !important;
}

.SmallCaps-module__m-r-16___M3BjQ {
  margin-right: 16px !important;
}

.SmallCaps-module__m-r-20___AvtQM {
  margin-right: 20px !important;
}

.SmallCaps-module__m-r-24___mRRWG {
  margin-right: 24px !important;
}

.SmallCaps-module__m-r-30___nMK_e {
  margin-right: 30px !important;
}

.SmallCaps-module__m-r-40___l2e1e {
  margin-right: 40px !important;
}

.SmallCaps-module__border-r-3___usNhW {
  border-radius: 3px !important;
}

.SmallCaps-module__border-r-4___eLPOj {
  border-radius: 4px !important;
}

.SmallCaps-module__border-r-6___dcOoh {
  border-radius: 6px !important;
}

.SmallCaps-module__border-r-10___YrbaK {
  border-radius: 10px !important;
}

.SmallCaps-module__border-r-12___fN3AW {
  border-radius: 12px !important;
}

.SmallCaps-module__border-r-16___Sq6H2 {
  border-radius: 16px !important;
}

.SmallCaps-module__border-r-50___C_E6l {
  border-radius: 50% !important;
}

.SmallCaps-module__primary-border___iwc6P {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SmallCaps-module__primary-border-b___jKHeN {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SmallCaps-module__primary-border-t___EMdpx {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SmallCaps-module__primary-border-l___CDPpc {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SmallCaps-module__primary-border-r___EAPoT {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SmallCaps-module__secondary-border___tiio3 {
  border: 1px solid #637768;
}

.SmallCaps-module__secondary-border-b___lZqW5 {
  border-bottom: 1px solid #637768;
}

.SmallCaps-module__secondary-border-t___t3U2E {
  border-top: 1px solid #637768;
}

.SmallCaps-module__secondary-border-l___KLbv_ {
  border-left: 1px solid #637768;
}

.SmallCaps-module__secondary-border-r___IeK6w {
  border-right: 1px solid #637768;
}

.SmallCaps-module__gap-0___yZimp {
  gap: 0 !important;
}

.SmallCaps-module__gap-2___UcQVB {
  gap: 2px !important;
}

.SmallCaps-module__gap-4___hzpFE {
  gap: 4px !important;
}

.SmallCaps-module__gap-5___vtaVw {
  gap: 5px !important;
}

.SmallCaps-module__gap-6___xxyo6 {
  gap: 6px !important;
}

.SmallCaps-module__gap-8___SKAbY {
  gap: 8px !important;
}

.SmallCaps-module__gap-10___HLjwB {
  gap: 10px !important;
}

.SmallCaps-module__gap-12___bmBkQ {
  gap: 12px !important;
}

.SmallCaps-module__gap-14___tTh8y {
  gap: 14px !important;
}

.SmallCaps-module__gap-16___6cNbp {
  gap: 16px !important;
}

.SmallCaps-module__gap-18___RqbsV {
  gap: 18px !important;
}

.SmallCaps-module__gap-20___ksbb4 {
  gap: 20px !important;
}

.SmallCaps-module__gap-24___rARMI {
  gap: 24px !important;
}

.SmallCaps-module__gap-26___Eabai {
  gap: 26px !important;
}

.SmallCaps-module__gap-30___Qo1rv {
  gap: 30px !important;
}

.SmallCaps-module__gap-32___vc4Fj {
  gap: 32px !important;
}

.SmallCaps-module__gap-40___v9HIn {
  gap: 40px !important;
}

.SmallCaps-module__gap-50___yL0Sy {
  gap: 50px !important;
}

.SmallCaps-module__flex-1___d0LGI {
  flex: 1;
}

.SmallCaps-module__flex-none___Rv5KS {
  flex: none !important;
}

.SmallCaps-module__flex-column___xPa34 {
  display: flex;
  flex-direction: column !important;
}

.SmallCaps-module__flex-row___Eyrgo {
  display: flex;
  flex-direction: row !important;
}

.SmallCaps-module__vertically-centered___ypEmW {
  display: flex;
  align-items: center !important;
}

.SmallCaps-module__horizontally-centered___osVb4 {
  display: flex;
  justify-content: center !important;
}

.SmallCaps-module__horizontally-end___RMczI {
  display: flex;
  justify-content: end !important;
}

.SmallCaps-module__vertically-start___oO1ZK {
  display: flex;
  align-items: start !important;
}

.SmallCaps-module__space-between___CkmZT {
  display: flex;
  justify-content: space-between !important;
}

.SmallCaps-module__flex-wrap___G26Tq {
  flex-wrap: wrap !important;
}

.SmallCaps-module__height-100___xpdaa {
  height: 100%;
}

.SmallCaps-module__width-50___hWu9l {
  width: 50% !important;
}

.SmallCaps-module__width-100___Hyhgf {
  width: 100%;
}

.SmallCaps-module__cursor-pointer___dnkWh {
  cursor: pointer;
}

.SmallCaps-module__cursor-not-allowed___WWUa4 {
  cursor: not-allowed !important;
}

.SmallCaps-module__absolute-centered____JREB {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SmallCaps-module__absolute___d0nai {
  position: absolute;
}

.SmallCaps-module__relative___muG61 {
  position: relative;
}

.SmallCaps-module__fixed___eVfzu {
  position: fixed;
}

.SmallCaps-module__visible___U7t7Y {
  opacity: 1;
}

.SmallCaps-module__invisible___lrQFt {
  opacity: 0;
}

.SmallCaps-module__col-90___LXm76 {
  width: 90% !important;
}

.SmallCaps-module__col-auto___wntdj {
  width: auto !important;
}

.SmallCaps-module__medical-tabs___QnOAR {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SmallCaps-module__medical-table-new___NLQ_A {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SmallCaps-module__medical-table-new___NLQ_A:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SmallCaps-module__medical-table-new___NLQ_A::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SmallCaps-module__medical-table-new___NLQ_A::-webkit-scrollbar-track {
  display: none;
}
.SmallCaps-module__medical-table-new___NLQ_A.SmallCaps-module__no-pagination___MoSgd {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SmallCaps-module__medical-table-new___NLQ_A.SmallCaps-module__no-pagination___MoSgd:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SmallCaps-module__medical-table-new___NLQ_A.SmallCaps-module__no-pagination___MoSgd::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SmallCaps-module__medical-table-new___NLQ_A.SmallCaps-module__no-pagination___MoSgd::-webkit-scrollbar-track {
  display: none;
}

.SmallCaps-module__medical-table-empty___nW9Jo {
  padding: 14px 40px !important;
}

.SmallCaps-module__icon-btn___Fd2tg {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SmallCaps-module__search-icon___MzKqq {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SmallCaps-module__disable-select___pC33X {
  user-select: none;
}

.SmallCaps-module__break-word___ikOnp {
  word-break: break-word;
}

.SmallCaps-module__popup-clear-btn___Zao7L {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SmallCaps-module__scroll-m-b-20___cP1pF {
  scroll-margin-bottom: 20px;
}

.SmallCaps-module__smallCaps___pSa6z {
  margin: 0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.SmallCaps-module__xs___kc08Z {
  font-size: 12px;
  line-height: 16px;
}

.SmallCaps-module__sm____TxGT {
  font-size: 13px;
  line-height: 1.4286;
}

.SmallCaps-module__label___YRfcf {
  color: #71717a;
}

.SmallCaps-module__muted___AlZ_0 {
  color: #52525b;
}

.SmallCaps-module__band___LkF4k {
  color: #3f3f46;
}

.SmallCaps-module__strong___D1jf6 {
  font-weight: 700;
  color: #18181b;
}

.SmallCaps-module__alert___PwDix {
  color: #b91c1c;
}

.SmallCaps-module__inverse___hg9pB {
  color: #ffffff;
}

.SmallCaps-module__done___wnZeg {
  color: #166534;
}

.SmallCaps-module__warn___kdrzp {
  color: #854d0e;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/Visit/SmallCaps.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBEGc;AF2pBhB;;AA3pBA;EACE,eAAA;EACA,iBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,cEbM;AF2qBR;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.smallCaps {\n  margin: 0;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: $tracking-caps;\n}\n\n.xs {\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.sm {\n  font-size: 13px;\n  line-height: 1.4286;\n}\n\n.label {\n  color: $label;\n}\n\n.muted {\n  color: #52525b;\n}\n\n.band {\n  color: #3f3f46;\n}\n\n.strong {\n  font-weight: 700;\n  color: #18181b;\n}\n\n.alert {\n  color: #b91c1c;\n}\n\n.inverse {\n  color: #ffffff;\n}\n\n.done {\n  color: #166534;\n}\n\n.warn {\n  color: #854d0e;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SmallCaps-module__font-s-10___ayzXB`,
	"fontS12": `SmallCaps-module__font-s-12___Kje6o`,
	"fontS13": `SmallCaps-module__font-s-13___sazbM`,
	"fontS14": `SmallCaps-module__font-s-14___qFy90`,
	"fontS15": `SmallCaps-module__font-s-15___Nl3zI`,
	"fontS16": `SmallCaps-module__font-s-16___dVCnX`,
	"fontS18": `SmallCaps-module__font-s-18___veGi5`,
	"fontS20": `SmallCaps-module__font-s-20___pOAN6`,
	"fontS22": `SmallCaps-module__font-s-22___a63nr`,
	"fontS28": `SmallCaps-module__font-s-28___OAV13`,
	"fontW400": `SmallCaps-module__font-w-400___u056O`,
	"fontW500": `SmallCaps-module__font-w-500___ZJNh1`,
	"fontW600": `SmallCaps-module__font-w-600___t4ZDj`,
	"fontW700": `SmallCaps-module__font-w-700___ipWoM`,
	"p5": `SmallCaps-module__p-5___bgq2J`,
	"p12": `SmallCaps-module__p-12___FW2LX`,
	"p16": `SmallCaps-module__p-16___Vj4xQ`,
	"p30": `SmallCaps-module__p-30____dD23`,
	"pB0": `SmallCaps-module__p-b-0___lqEws`,
	"pB5": `SmallCaps-module__p-b-5___NGtgJ`,
	"pB10": `SmallCaps-module__p-b-10___fZW6z`,
	"pB12": `SmallCaps-module__p-b-12___v8VVf`,
	"pB16": `SmallCaps-module__p-b-16___Xd_Jv`,
	"pB18": `SmallCaps-module__p-b-18___YTVy8`,
	"pB20": `SmallCaps-module__p-b-20___dc1tL`,
	"pB25": `SmallCaps-module__p-b-25___c1ZuR`,
	"pB30": `SmallCaps-module__p-b-30___fNCW0`,
	"pB50": `SmallCaps-module__p-b-50____bf_i`,
	"pT0": `SmallCaps-module__p-t-0___fAdTf`,
	"pT12": `SmallCaps-module__p-t-12___Lhm2n`,
	"pT16": `SmallCaps-module__p-t-16___tBRBj`,
	"pT18": `SmallCaps-module__p-t-18___weJzq`,
	"pT20": `SmallCaps-module__p-t-20___Zhyt0`,
	"pT30": `SmallCaps-module__p-t-30___hgb9n`,
	"pT40": `SmallCaps-module__p-t-40____DVC7`,
	"pT50": `SmallCaps-module__p-t-50___hoLJb`,
	"pL20": `SmallCaps-module__p-l-20___DEFvK`,
	"pL30": `SmallCaps-module__p-l-30___J4m9i`,
	"pL40": `SmallCaps-module__p-l-40___CDXPN`,
	"pR16": `SmallCaps-module__p-r-16___aVV87`,
	"pR20": `SmallCaps-module__p-r-20___Ftqjc`,
	"pR30": `SmallCaps-module__p-r-30___ByM8m`,
	"pR50": `SmallCaps-module__p-r-50___g_mTq`,
	"pR60": `SmallCaps-module__p-r-60___m1MzD`,
	"mB1": `SmallCaps-module__m-b-1___GBddB`,
	"mB2": `SmallCaps-module__m-b-2___FLTR6`,
	"mB6": `SmallCaps-module__m-b-6___WNnKn`,
	"mB8": `SmallCaps-module__m-b-8___uYrig`,
	"mB10": `SmallCaps-module__m-b-10___Gwb2A`,
	"mB14": `SmallCaps-module__m-b-14___D3uiX`,
	"mB16": `SmallCaps-module__m-b-16___uMBNi`,
	"mB20": `SmallCaps-module__m-b-20___gv3qC`,
	"mB22": `SmallCaps-module__m-b-22___fGKYq`,
	"mB24": `SmallCaps-module__m-b-24___TYnrN`,
	"mB30": `SmallCaps-module__m-b-30___QbAFc`,
	"mB32": `SmallCaps-module__m-b-32___VH_Ai`,
	"mB40": `SmallCaps-module__m-b-40___INmot`,
	"mT2": `SmallCaps-module__m-t-2___VqNaP`,
	"mT3": `SmallCaps-module__m-t-3___ntkNt`,
	"mT4": `SmallCaps-module__m-t-4___X2gFp`,
	"mT5": `SmallCaps-module__m-t-5___W1tYB`,
	"mT8": `SmallCaps-module__m-t-8___AH6LM`,
	"mT10": `SmallCaps-module__m-t-10___CwQF6`,
	"mT15": `SmallCaps-module__m-t-15___Au0Xi`,
	"mT16": `SmallCaps-module__m-t-16___YF682`,
	"mT20": `SmallCaps-module__m-t-20___G8aLt`,
	"mT22": `SmallCaps-module__m-t-22___E6hOH`,
	"mT30": `SmallCaps-module__m-t-30___VJx90`,
	"mT32": `SmallCaps-module__m-t-32___odyqC`,
	"mLAuto": `SmallCaps-module__m-l-auto___qTBli`,
	"mL4": `SmallCaps-module__m-l-4___WZoK6`,
	"mL5": `SmallCaps-module__m-l-5___VuwsW`,
	"mL6": `SmallCaps-module__m-l-6___ouHKD`,
	"mL8": `SmallCaps-module__m-l-8___C4IqL`,
	"mL10": `SmallCaps-module__m-l-10___YPmSm`,
	"mL16": `SmallCaps-module__m-l-16___rCAvq`,
	"mL20": `SmallCaps-module__m-l-20___P8rNc`,
	"mL24": `SmallCaps-module__m-l-24___U7h7l`,
	"mL30": `SmallCaps-module__m-l-30___ll5BA`,
	"mL35": `SmallCaps-module__m-l-35___QX6lA`,
	"mL40": `SmallCaps-module__m-l-40___njsmj`,
	"mR8": `SmallCaps-module__m-r-8___yVB1v`,
	"mR10": `SmallCaps-module__m-r-10___GsYIB`,
	"mR16": `SmallCaps-module__m-r-16___M3BjQ`,
	"mR20": `SmallCaps-module__m-r-20___AvtQM`,
	"mR24": `SmallCaps-module__m-r-24___mRRWG`,
	"mR30": `SmallCaps-module__m-r-30___nMK_e`,
	"mR40": `SmallCaps-module__m-r-40___l2e1e`,
	"borderR3": `SmallCaps-module__border-r-3___usNhW`,
	"borderR4": `SmallCaps-module__border-r-4___eLPOj`,
	"borderR6": `SmallCaps-module__border-r-6___dcOoh`,
	"borderR10": `SmallCaps-module__border-r-10___YrbaK`,
	"borderR12": `SmallCaps-module__border-r-12___fN3AW`,
	"borderR16": `SmallCaps-module__border-r-16___Sq6H2`,
	"borderR50": `SmallCaps-module__border-r-50___C_E6l`,
	"primaryBorder": `SmallCaps-module__primary-border___iwc6P`,
	"primaryBorderB": `SmallCaps-module__primary-border-b___jKHeN`,
	"primaryBorderT": `SmallCaps-module__primary-border-t___EMdpx`,
	"primaryBorderL": `SmallCaps-module__primary-border-l___CDPpc`,
	"primaryBorderR": `SmallCaps-module__primary-border-r___EAPoT`,
	"secondaryBorder": `SmallCaps-module__secondary-border___tiio3`,
	"secondaryBorderB": `SmallCaps-module__secondary-border-b___lZqW5`,
	"secondaryBorderT": `SmallCaps-module__secondary-border-t___t3U2E`,
	"secondaryBorderL": `SmallCaps-module__secondary-border-l___KLbv_`,
	"secondaryBorderR": `SmallCaps-module__secondary-border-r___IeK6w`,
	"gap0": `SmallCaps-module__gap-0___yZimp`,
	"gap2": `SmallCaps-module__gap-2___UcQVB`,
	"gap4": `SmallCaps-module__gap-4___hzpFE`,
	"gap5": `SmallCaps-module__gap-5___vtaVw`,
	"gap6": `SmallCaps-module__gap-6___xxyo6`,
	"gap8": `SmallCaps-module__gap-8___SKAbY`,
	"gap10": `SmallCaps-module__gap-10___HLjwB`,
	"gap12": `SmallCaps-module__gap-12___bmBkQ`,
	"gap14": `SmallCaps-module__gap-14___tTh8y`,
	"gap16": `SmallCaps-module__gap-16___6cNbp`,
	"gap18": `SmallCaps-module__gap-18___RqbsV`,
	"gap20": `SmallCaps-module__gap-20___ksbb4`,
	"gap24": `SmallCaps-module__gap-24___rARMI`,
	"gap26": `SmallCaps-module__gap-26___Eabai`,
	"gap30": `SmallCaps-module__gap-30___Qo1rv`,
	"gap32": `SmallCaps-module__gap-32___vc4Fj`,
	"gap40": `SmallCaps-module__gap-40___v9HIn`,
	"gap50": `SmallCaps-module__gap-50___yL0Sy`,
	"flex1": `SmallCaps-module__flex-1___d0LGI`,
	"flexNone": `SmallCaps-module__flex-none___Rv5KS`,
	"flexColumn": `SmallCaps-module__flex-column___xPa34`,
	"flexRow": `SmallCaps-module__flex-row___Eyrgo`,
	"verticallyCentered": `SmallCaps-module__vertically-centered___ypEmW`,
	"horizontallyCentered": `SmallCaps-module__horizontally-centered___osVb4`,
	"horizontallyEnd": `SmallCaps-module__horizontally-end___RMczI`,
	"verticallyStart": `SmallCaps-module__vertically-start___oO1ZK`,
	"spaceBetween": `SmallCaps-module__space-between___CkmZT`,
	"flexWrap": `SmallCaps-module__flex-wrap___G26Tq`,
	"height100": `SmallCaps-module__height-100___xpdaa`,
	"width50": `SmallCaps-module__width-50___hWu9l`,
	"width100": `SmallCaps-module__width-100___Hyhgf`,
	"cursorPointer": `SmallCaps-module__cursor-pointer___dnkWh`,
	"cursorNotAllowed": `SmallCaps-module__cursor-not-allowed___WWUa4`,
	"absoluteCentered": `SmallCaps-module__absolute-centered____JREB`,
	"absolute": `SmallCaps-module__absolute___d0nai`,
	"relative": `SmallCaps-module__relative___muG61`,
	"fixed": `SmallCaps-module__fixed___eVfzu`,
	"visible": `SmallCaps-module__visible___U7t7Y`,
	"invisible": `SmallCaps-module__invisible___lrQFt`,
	"col90": `SmallCaps-module__col-90___LXm76`,
	"colAuto": `SmallCaps-module__col-auto___wntdj`,
	"medicalTabs": `SmallCaps-module__medical-tabs___QnOAR`,
	"medicalTableNew": `SmallCaps-module__medical-table-new___NLQ_A`,
	"noPagination": `SmallCaps-module__no-pagination___MoSgd`,
	"medicalTableEmpty": `SmallCaps-module__medical-table-empty___nW9Jo`,
	"iconBtn": `SmallCaps-module__icon-btn___Fd2tg`,
	"searchIcon": `SmallCaps-module__search-icon___MzKqq`,
	"disableSelect": `SmallCaps-module__disable-select___pC33X`,
	"breakWord": `SmallCaps-module__break-word___ikOnp`,
	"popupClearBtn": `SmallCaps-module__popup-clear-btn___Zao7L`,
	"scrollMB20": `SmallCaps-module__scroll-m-b-20___cP1pF`,
	"smallCaps": `SmallCaps-module__smallCaps___pSa6z`,
	"xs": `SmallCaps-module__xs___kc08Z`,
	"sm": `SmallCaps-module__sm____TxGT`,
	"label": `SmallCaps-module__label___YRfcf`,
	"muted": `SmallCaps-module__muted___AlZ_0`,
	"band": `SmallCaps-module__band___LkF4k`,
	"strong": `SmallCaps-module__strong___D1jf6`,
	"alert": `SmallCaps-module__alert___PwDix`,
	"inverse": `SmallCaps-module__inverse___hg9pB`,
	"done": `SmallCaps-module__done___wnZeg`,
	"warn": `SmallCaps-module__warn___kdrzp`
};
module.exports = ___CSS_LOADER_EXPORT___;
